
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"62","height":"62","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M59.767 28.403c1.468 16.453-10.477 31.05-26.655 32.483C16.934 62.32 2.59 50.051 1.122 33.598-.346 17.144 11.6 2.548 27.777 1.114c6.068-.536 12.1.824 17.405 3.942.643.348.855 1.21.505 1.85-.35.64-1.214.853-1.863.436-4.798-2.757-10.279-4.03-15.808-3.541C13.322 5.102 2.481 18.382 3.818 33.359 5.155 48.335 18.176 59.501 32.872 58.2c14.695-1.3 25.536-14.58 24.198-29.558a1.353 1.353 0 012.697-.238","fill":"#FFE86C"}}),_c('path',{attrs:{"d":"M59.767 28.403c1.468 16.453-10.477 31.05-26.655 32.483C16.934 62.32 2.59 50.051 1.122 33.598-.346 17.144 11.6 2.548 27.777 1.114c6.068-.536 12.1.824 17.405 3.942.643.348.855 1.21.505 1.85-.35.64-1.214.853-1.863.436-4.798-2.757-10.279-4.03-15.808-3.541C13.322 5.102 2.481 18.382 3.818 33.359 5.155 48.335 18.176 59.501 32.872 58.2c14.695-1.3 25.536-14.58 24.198-29.558a1.353 1.353 0 012.697-.238z","stroke":"#FFF","stroke-width":".6"}}),_c('path',{attrs:{"d":"M60.474 4.67c-.607-.512-1.512-.43-1.95.176l-27.9 34.294-9.56-11.933c-.607-.513-1.443-.437-1.95.175a1.372 1.372 0 00.173 1.966l10.621 13.535a1.37 1.37 0 001.013.334c.347-.032.753-.209.937-.51L60.723 6.702a1.527 1.527 0 00-.25-2.03","fill":"#005149"}}),_c('path',{attrs:{"d":"M60.474 4.67c-.607-.512-1.512-.43-1.95.176l-27.9 34.294-9.56-11.933c-.607-.513-1.443-.437-1.95.175a1.372 1.372 0 00.173 1.966l10.621 13.535a1.37 1.37 0 001.013.334c.347-.032.753-.209.937-.51L60.723 6.702a1.527 1.527 0 00-.25-2.03z","stroke":"#FFF","stroke-width":".6"}})])])
          )
        }
      }
    